/* eslint-disable no-useless-escape, no-magic-numbers, no-undef */

import { cookiesEnv } from '@env/cookiesEnv'

export function checkIsMobile(userAgent) {
  let check = false
  ;(function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true
  })(userAgent || navigator.userAgent)
  return check
}

export function getBrowserName() {
  const isBrave = window.navigator && !!window.navigator.brave
  const isIE = /* @cc_on!@*/ false || !!document.documentMode
  const { userAgent } = window.navigator

  switch (true) {
  case !!userAgent.match(/SmartTV/i) || !!userAgent.match(/Smart-TV/i):
    return 'SmartTV'
  case !!userAgent.match(/FBAV\/([0-9\.]+)/) || !!userAgent.match(/FBAN/):
    return 'Facebook'
  case !!userAgent.match(/Instagram\s([0-9\.]+)/):
    return 'Instagram'
  case !!userAgent.match(/YaBrowser\s([0-9\.]+)/):
    return 'YaBrowser'
  case !!userAgent.match(/LinkedIn\s([0-9\.]+)/):
    return 'LinkedIn'
  case !!userAgent.match(/SamsungBrowser\/([0-9\.]+)/):
    return 'Samsung Internet'
  case (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0:
    return 'Opera'
  case typeof InstallTrigger !== 'undefined':
    return 'Firefox'
  case /constructor/i.test(window.HTMLElement) ||
      (function (p) {
        return p.toString() === '[object SafariRemoteNotification]'
      })(!window.safari || (typeof safari !== 'undefined' && safari.pushNotification)) ||
      !!userAgent.match(/Version\/([0-9\._]+).*Safari.*/):
    return 'Safari'
  case isIE:
    return 'InternetExplorer'
  case !isIE && !!window.StyleMedia:
    return 'MicrosoftEdge'
  case !!window.chrome && !isBrave:
    return 'Chrome'
  case isBrave:
    return 'Brave'
  case !!userAgent.match(/Android\s([0-9\.]+)/):
    return 'Android'
  case !!userAgent.match(/Version\/([0-9\._]+).*Mobile.*Safari.*/):
    return 'iOS'
  case !!userAgent.match(/AppleWebKit\/([0-9\.]+).*Mobile/) || !!userAgent.match(/AppleWebKit\/([0-9\.]+).*Gecko\)$/):
    return 'iOS-Webview'
  default:
    return userAgent
  }
}

export function getCookie(key) {
  const cookie = String(document.cookie).split(';')
  const name = `${key}=`

  for (let i = 0; i < cookie.length; i++) {
    while (cookie[i].charAt(0) === ' ') {
      cookie[i] = cookie[i].substring(1, cookie[i].length)
    }

    if (cookie[i].indexOf(name) === 0) {
      return decodeURIComponent(cookie[i].substring(name.length, cookie[i].length))
    }
  }

  return null
}

export function setCookieDefault(cookieName, cookieValue, expirationDays) {
  setCookie(cookieName, cookieValue, expirationDays, true, 'lax', false)
}

export function setCookieDefaultIfDontExist(cookieName, cookieValue, expirationDays) {
  if (getCookie(cookieName)) return

  setCookieDefault(cookieName, cookieValue, expirationDays)
}

const validateCookieLength = function(cookieValue) {
  if (cookieValue.length > 256) {
    throw new Error('Tamanho do cookie maior que o permitido || Tamanho máximo permitido: 256')
  }

  return true
}

const setCookie = function(cookieName, cookieValue, expiration, hasSecure, sameSiteType, isExpirationInHours) {
  if (!validateCookieLength(cookieValue)) return

  const date = new Date()
  let secure = ''
  let expires = ''
  let sameSite = ''

  if (isExpirationInHours) {
    date.setTime(date.getTime() + (expiration * 60 * 60 * 1000))
  } else {
    date.setTime(date.getTime() + (expiration * 24 * 60 * 60 * 1000))
  }

  expires = `; expires=${date.toGMTString()}`

  if (hasSecure) secure = '; Secure'
  if (sameSiteType) sameSite = `; SameSite=${sameSiteType}`

  const domain = `; domain=${cookiesEnv.NEXT_PUBLIC_COOKIE_DOMAIN}`
  const cookie = `${cookieName}=${cookieValue}${expires}; path=/${secure}${sameSite}${domain}`

  document.cookie = cookie
}

export function getCleanReferer() {
  let referer = document.referrer.toString()

  if (referer.indexOf('?') > 0) referer = referer.substring(0, referer.indexOf('?'))

  const maxLength = 255
  if (referer.length > maxLength) referer = referer.substring(0, maxLength)

  return referer
}
